import React from 'react';
import { GlobalStyles } from '@mui/material';

const GlobalStyleOverrides: React.FC = () => {
  return (
    <GlobalStyles
      styles={{
        '*': {
          boxSizing: 'border-box',
        },
        'html, body, #spaRootContainer': {
          height: '100%',
        },
        body: {
          margin: 0,
          padding: 0,
          fontFamily:
            "'Open Sans', Arial, 'Helvetica Neue', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: '24px',
          letterSpacing: 0,
          backgroundColor: '#fbf9f7',
          color: '#1f0a1b',
          WebkitFontSmoothing: 'antialiased',
        },
        'h1, h2, h3, h4, h5, h6': {
          fontFamily:
            "'Open Sans', Arial, 'Helvetica Neue', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          fontWeight: 700,
          letterSpacing: 0,
          margin: 0,
        },
        h1: { fontSize: '24px', lineHeight: '32px' },
        h2: { fontSize: '20px', lineHeight: '28px' },
        'h3, h4': { fontSize: '16px', lineHeight: '24px' },
        p: {
          fontSize: '16px',
          lineHeight: '24px',
          margin: 0,
          backgroundColor: 'unset',
        },
        '.MuiSnackbar-root': {
          '& .MuiAlert-root': {
            alignItems: 'center',
          },
        },
        // Shared shimmer keyframes for the loading skeletons (SHIMMER_* sx helpers).
        '@keyframes shimmer': {
          '0%': { backgroundPosition: '-200% 0' },
          '100%': { backgroundPosition: '200% 0' },
        },
      }}
    />
  );
};

export default GlobalStyleOverrides;
